var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 470,
    zoomAndPan: "magnify",
    viewBox: "0 0 352.5 112.499997",
    height: 150,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.96078, 87.11176)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 38.796875 1.023438 C 51.0625 1.023438 59.496094 -5.777344 62.410156 -13.1875 L 62.515625 0 L 69.261719 0 L 69.261719 -36.546875 L 45.082031 -36.546875 L 45.082031 -30.15625 L 61.59375 -30.15625 C 61.339844 -14.925781 51.113281 -6.542969 38.796875 -6.542969 C 21.46875 -6.542969 14.363281 -20.445312 14.363281 -36.648438 C 14.363281 -52.035156 21.46875 -65.785156 38.59375 -65.785156 C 48.765625 -65.785156 56.277344 -60.519531 60.621094 -50.960938 L 68.035156 -54.183594 C 62.515625 -66.652344 52.289062 -73.402344 38.695312 -73.402344 C 16.765625 -73.402344 6.390625 -56.226562 6.390625 -36.136719 C 6.390625 -16 16.5625 1.023438 38.796875 1.023438 Z M 38.796875 1.023438 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.42154, 87.11176)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 38.644531 1.023438 C 60.726562 1.023438 71.152344 -16.101562 71.152344 -36.136719 C 71.152344 -56.125 60.726562 -73.300781 38.644531 -73.300781 C 16.664062 -73.300781 6.289062 -56.125 6.289062 -36.136719 C 6.289062 -16.101562 16.664062 1.023438 38.644531 1.023438 Z M 38.644531 -6.441406 C 21.316406 -6.441406 14.210938 -20.652344 14.210938 -36.136719 C 14.210938 -51.574219 21.316406 -65.785156 38.644531 -65.785156 C 56.226562 -65.785156 63.28125 -51.574219 63.28125 -36.136719 C 63.28125 -20.652344 56.226562 -6.441406 38.644531 -6.441406 Z M 38.644531 -6.441406 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.18899, 87.11176)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 29.699219 0 L 37.671875 0 L 37.671875 -28.265625 L 64.609375 -72.226562 L 55.152344 -72.226562 L 33.582031 -36.496094 L 12.164062 -72.226562 L 2.65625 -72.226562 L 29.699219 -28.265625 Z M 29.699219 0 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(264.784541, 87.11176)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.21875 0 L 12.0625 0 L 17.582031 -15.691406 L 49.324219 -15.691406 L 54.847656 0 L 63.535156 0 L 36.597656 -72.226562 L 30.363281 -72.226562 Z M 20.292969 -23.105469 L 33.53125 -60.316406 L 46.566406 -23.105469 Z M 20.292969 -23.105469 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fb4aa4b88ace6852466fa693ab5ca84e.svg";
export { ForwardRef as ReactComponent };